
import { httpV2 } from "@/api/index";

/**
* @summary Obtem o Operating Range para um registro específico.
* @param {Number - String} resultSetId - Id do registro.
* @returns {Object - Json} Retorna status do diagnóstico de desalinhamento angular do eixo principal.
*/
const GetMainShaftAngularMisalignmentResult = function(resultSetId)
{
	return new Promise((resolve) =>
	{
		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/AngularMisalignmentMainShaft`)
			.then((resp) =>
			{
				resolve(resp.data);
			});
	});
};

/**
* @summary Obtem os dados para construção do gráfico avançado do desalinhamento angular do mancal principal.
* @param {Number - String} resultSetId - Id do registro.
* @returns {Object - Json} Retorna os eixos do gráfico e frequências de interesse.
*/
const GetMainShaftAngularMisalignmentChartData = function(resultSetId)
{
	return new Promise((resolve, reject) =>
	{
		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/AngularMisalignmentMainShaft/Chart`)
			.then((resp) =>
			{
				resolve(resp.data);
			})
			.catch((error) =>
			{
				reject(error);
			});
	});
};

/**
 * @summary Obtém as informações dos sinais de um diagnóstico.
 * @param {number} id - Id do diagnóstico.
 * @returns {promise} Promise da chamada da API.
 */
const GetDiagnosticSignals = function(id)
{
	return httpV2.get(`/AngularMisalignmentMainShaftSettings/${id}/Signals`);
};

export default {
	GetMainShaftAngularMisalignmentResult,
	GetMainShaftAngularMisalignmentChartData,
	GetDiagnosticSignals
};
